<template>
  <BaseConvertor pageHeading="Base Convertor" />
</template>

<script>
import BaseConvertor from "./components/BaseConvertor.vue";

export default {
  name: "App",
  components: {
    BaseConvertor,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
